export const DEFAULT_ROTATE_ANGLES: number[] = [0];
export const DEFAULT_DRAW_OUT_OF_BOUND = 'hidden';
export const DEFAULT_MIN_FONT_SIZE = 20;
export const DEFAULT_FONTSIZE_RANGE: [number, number] = [20, 40];
export const DEFAULT_FONT_WEIGHT_RANGE: [number, number] = [200, 500];
export const DEFAULT_MASK_SHAPE = 'circle';
export const DEFAULT_ZOOM_TO_FIT = {
  shrink: false,
  enlarge: false,
  fontSizeLimitMin: 0
};
export const DEFAULT_RANDOM = true;
export const DEFAULT_FONT_PADDING = 1;
export const DEFAULT_TEXT_ALIGN = 'center';
export const DEFAULT_TEXT_BASE_LINE = 'alphabetic';
export const SHAPE_TYPE = [
  'triangleForward',
  'triangle',
  'diamond',
  'square',
  'star',
  'cardioid',
  'circle',
  'pentagon',
  'rect'
];
